import React from 'react';
import { createPortal } from 'react-dom';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { calcSizeForDevice } from 'utils/index';

import NewGradientButton from 'components/Button/NewGradienteButton';
import { ResetPinConfirmModalProps } from 'components/Pin/ResetPinConfirmModal';
import { WebDiv } from 'components/WebDiv';
import IsLoading from 'components/isLoading';

export const TvResetPinConfirmModal = ({
  isOpen,
  isLoading,
  onConfirm,
  onCancel,
}: ResetPinConfirmModalProps): React.ReactNode => {
  if (!isOpen) return null;

  if (isLoading) {
    return createPortal(
      <WebDiv className="fullscreen-overlay navigation-container navigation-ignore">
        <View style={styles.overlay}>
          <IsLoading />
        </View>
      </WebDiv>,
      document.getElementById('root')!
    );
  }

  return createPortal(
    <WebDiv className="fullscreen-overlay navigation-container navigation-priority">
      <View style={styles.overlay}>
        <View style={styles.container}>
          <Text style={styles.title}>Redefinir PIN</Text>

          <Text style={styles.text}>Tem certeza de que deseja redefinir seu PIN?</Text>
          <Text style={styles.text}>Um novo PIN será gerado e enviado para seu e-mail.</Text>

          <View style={styles.buttons}>
            <NewGradientButton style={styles.confirmBtn} onPress={onConfirm}>
              <Text style={styles.confirmBtnText}>Redefinir</Text>
            </NewGradientButton>

            <Pressable accessibilityRole="button" style={styles.cancelBtn} onPress={onCancel}>
              <Text style={styles.cancelBtnText}>Cancelar</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </WebDiv>,
    document.getElementById('root')!
  );
};

const styles = StyleSheet.create({
  overlay: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.85)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: calcSizeForDevice(600),
    padding: calcSizeForDevice(40),
    backgroundColor: '#050923',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#182DB3',
  },
  loading: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: calcSizeForDevice(32),
    fontWeight: '700',
    color: '#7A8CFF',
    textAlign: 'center',
    marginBottom: 24,
  },
  text: {
    color: '#FFF',
    fontSize: calcSizeForDevice(20),
    textAlign: 'center',
  },
  buttons: {
    alignItems: 'center',
    marginTop: calcSizeForDevice(48),
  },
  confirmBtn: {
    height: calcSizeForDevice(54),
    marginHorizontal: calcSizeForDevice(32),
  },
  confirmBtnText: {
    fontSize: calcSizeForDevice(20),
    fontWeight: '600',
    color: '#070D31',
  },
  cancelBtn: {
    width: calcSizeForDevice(186),
    height: calcSizeForDevice(54),
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: calcSizeForDevice(16),
  },
  cancelBtnText: {
    color: '#FFF',
    fontSize: calcSizeForDevice(18),
  },
});
